import React, { useState } from "react";

const ButtonGroup = ({
  buttonOptions,
  onButtonClick,
  onSelect,
  buttonGroupVer,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (btnKey) => {
    const updatedOptions = { ...buttonOptions };

    if (selectedButton === btnKey) {
      // 선택된 버튼 다시 클릭 시 "_(1)" 제거
      updatedOptions[btnKey] = updatedOptions[btnKey].replace(/_\(\d+\)$/, "");
      setSelectedButton(null); // 선택 해제
      onSelect(null); // 선택 해제 시 null 전달
    } else {
      // 다른 버튼 클릭 시 모든 버튼 초기화 후 새 버튼 선택
      Object.keys(updatedOptions).forEach((key) => {
        updatedOptions[key] = updatedOptions[key].replace(/_\(\d+\)$/, "");
      });
      updatedOptions[btnKey] = `${updatedOptions[btnKey]}_(1)`;
      setSelectedButton(btnKey);
      onSelect(btnKey); // 선택된 버튼 키 전달
    }

    onButtonClick(updatedOptions); // 부모 컴포넌트에 업데이트된 상태 전달
  };

  return (
    <div
      className={`custom-button-group_14${
        buttonGroupVer ? `_${buttonGroupVer}` : ""
      }`}
    >
      {Object.entries(buttonOptions).map(([key, value]) => (
        <div
          className={`custom-button ${
            selectedButton === key ? "custom-button-selected" : ""
          }`}
          key={key}
          onClick={() => handleClick(key)}
        >
          <img
            src={`${value}.png`}
            alt={`Option ${key}`}
            className="custom-button-image"
          />
        </div>
      ))}
    </div>
  );
};

export default ButtonGroup;
